export const ACTIONS = {
  PUSH_STUDENT_EVENT: 'PUSH_STUDENT_EVENT',
  PUSH_STUDENT_EVENTS: 'PUSH_STUDENT_EVENTS',
  CLEAR_STUDENT_EVENTS: 'CLEAR_STUDENT_EVENTS',
};

export const pushEvent = event => dispatch => {
  dispatch({
    type: ACTIONS.PUSH_STUDENT_EVENT,
    payload: {
      event,
    },
  });
};
